import { useCallback } from 'react'

export type ControlPlane = {
  name: string
  appDomain: string
  appPort?: string
  protocol?: string
}

const controlPlaneUrl = (controlPlane: ControlPlane) =>
  `${controlPlane.protocol ?? 'https://'}${controlPlane.appDomain}${controlPlane.appPort ?? ''}`

export type ProbeResult = {
  readonly name: string
  readonly appDomain: string
  readonly url: string
}

type MaybeProbeResult = ProbeResult | undefined

type RawProbeResult = {
  readonly exists: boolean
  readonly appDomain: string
}

export type Probe = (email: string) => Promise<ProbeResult[]>

export function useProbe(): Probe {
  return useCallback<Probe>(async (email: string) => {
    const resp = await fetch('/controlplanes.json')
    const controlPlanes: ControlPlane[] = await resp.json()
    const results: MaybeProbeResult[] = await Promise.all(
      controlPlanes.map(async (controlPlane) => {
        const url = controlPlaneUrl(controlPlane)
        try {
          const resp = await fetch(`${url}/auth/probe`, {
            method: 'POST',
            body: JSON.stringify({ id: email }),
          })
          const rawResult = (await resp.json()) as RawProbeResult
          if (!rawResult.exists) {
            return undefined
          }
          const controlPlaneWithProbedAppDomain = {
            ...controlPlane,
            appDomain: rawResult.appDomain,
          }
          return {
            ...controlPlane,
            url: controlPlaneUrl(controlPlaneWithProbedAppDomain),
          }
        } catch (e) {
          return undefined
        }
      }),
    )
    return results.filter((x) => x !== undefined)
  }, [])
}
